import React, { useMemo } from "react";
import { useHSE } from "../lib/store";

export default function SiteMap() {
  const { data, filters, setFilters } = useHSE();
  const sites = data.settings.sites || [];

  const stats = useMemo(() => {
    const map = {};
    sites.forEach((s) => {
      const sn = s.number || s;
      const incidents = data.incidents.filter((r) => r.site === sn).length;
      const openActions = data.actions.filter((r) => r.site === sn && (r.status === "Open" || r.status === "Overdue")).length;
      const openFindings = data.observations.filter((r) => r.site === sn && r.status !== "Closed").length;
      const overdue = data.actions.filter((r) => r.site === sn && r.status === "Overdue").length;
      const inspections = data.inspections.filter((r) => r.site === sn).length;
      const inactive = typeof s === "object" && s.status === "Inactive";

      let risk = "safe";
      const score = incidents * 2 + openFindings * 3 + overdue * 2;
      if (inactive) risk = "inactive";
      else if (score > 18) risk = "critical";
      else if (score > 8) risk = "warning";

      map[sn] = { incidents, openActions, openFindings, overdue, inspections, risk, inactive, zone: s.region || "Project Zone" };
    });
    return map;
  }, [data, sites]);

  const visible = sites.filter((s) => {
    if (filters.region !== "All Regions" && typeof s === "object" && s.region !== filters.region) return false;
    return true;
  });

  return (
    <div className="grid grid-cols-6 sm:grid-cols-8 md:grid-cols-12 lg:grid-cols-[repeat(14,minmax(0,1fr))] xl:grid-cols-[repeat(17,minmax(0,1fr))] gap-1.5">
      {visible.map((s) => {
        const sn = typeof s === "object" ? s.number : s;
        const st = stats[sn];
        const selected = filters.site === sn;
        return (
          <div
            key={sn}
            data-testid={`site-marker-${sn.replace(/\s+/g, "-")}`}
            onClick={() => setFilters({ ...filters, site: selected ? "All Sites" : sn })}
            className={`site-marker ${st.risk} ${selected ? "selected" : ""}`}
            title={`${sn} - ${st.zone} - Incidents ${st.incidents} - Open findings ${st.openFindings} - Overdue actions ${st.overdue}`}
          >
            {sn.replace("Construction ", "")}
            <div className="text-[8px] mt-0.5 opacity-75 font-mono">
              {st.incidents}-{st.openFindings}
            </div>
          </div>
        );
      })}
    </div>
  );
}
